import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-form-subtitle',
  templateUrl: './form-subtitle.component.html',
  styleUrls: ['./form-subtitle.component.css'],
})
export class FormSubtitleComponent implements OnInit {
  @Input() title: string;
  @Input() hasBorder = false;

  constructor() {}

  ngOnInit() {}
}
